import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import UserList from '../views/UserList.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/users',
    children: [
      {
        path: 'users',
        name: 'UserList',
        component: UserList,
        meta: { title: '报名人员列表' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('adminToken')
  
  if (to.meta.public) {
    next()
  } else if (!isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
